import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { Link, Redirect } from 'react-router-dom';
import { ROUTING_CONFIG, supportArticleRoute } from '@uplift/constants';
import { Button } from '@uplift/ui-v2';
import { MainLayout } from '../../components';
import { getSupportArticleBySlug } from './articles';
import { useSupportArticleStyles } from './articles/article-shared';

export const SupportArticlePage = () => {
  const { slug } = supportArticleRoute.useParams();
  const article = getSupportArticleBySlug(slug);
  const { classes } = useSupportArticleStyles();

  if (!article) {
    return <Redirect to={ROUTING_CONFIG.support} />;
  }

  const ArticleContent = article.Component;

  return (
    <MainLayout>
      <Container className={classes.content}>
        <Button
          component={Link}
          to={ROUTING_CONFIG.support}
          color="secondary"
          startIcon={<ArrowBack />}
          sx={{ mb: 2, px: 0 }}
        >
          Back to Help Center
        </Button>
        <Typography variant="h3" component="h1" gutterBottom>
          {article.title}
        </Typography>
        <Box mt={2}>
          <ArticleContent />
        </Box>
      </Container>
    </MainLayout>
  );
};
